import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { CircularProgress, Container, Typography, Button, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

// Redux
import { connect } from 'react-redux';
import { setSuccess, clearErrors, setAlert } from '../../../../redux/actions/alertActions';

// API
import { getBadge, listBadgeTypes, updateBadge } from '../../../../api';

// Components
import LineItem from '../../../../components/LineItem';

class Badge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToBadges: false,
      badge: null,
      badgeTypes: [],
      selectedBadgeTypeID: null,
      isLoading: false,
      isSaving: false
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    const badgeID = this.props.match?.params?.id;
    
    // Load badge details and badge types
    Promise.all([
      getBadge(badgeID),
      listBadgeTypes()
    ]).then(([badge, badgeTypes]) => {
      this.setState({ 
        badge: badge, 
        badgeTypes: badgeTypes,
        selectedBadgeTypeID: badge.getBadgeType()?.getID() || null,
        isLoading: false 
      });
    }).catch(error => {
      this.setState({ isLoading: false });
      this.props.setError(error ? error : 'Error: Unable to retrieve badge.');
    });
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  handleBadgeTypeChange = (event) => {
    this.setState({ selectedBadgeTypeID: event.target.value });
  }

  handleSaveBadgeType = () => {
    if (!this.state.selectedBadgeTypeID) {
      this.props.setError('Please select a badge type.');
      return;
    }

    this.setState({ isSaving: true });

    updateBadge({
      serialNumber: this.state.badge.getSerialNumber(),
      badgeTypeID: this.state.selectedBadgeTypeID
    }).then(() => {
      this.props.setSuccess('Badge type updated successfully!');
      // Reload badge data
      return getBadge(this.state.badge.getSerialNumber());
    }).then(badge => {
      this.setState({ 
        badge: badge,
        selectedBadgeTypeID: badge.getBadgeType()?.getID() || null,
        isSaving: false 
      });
    }).catch(error => {
      this.setState({ isSaving: false });
      this.props.setError(error ? error : 'Error: Unable to update badge type.');
    });
  }

  render() {
    const isSuperAdmin = this.props.userType.name === 'Super';
    
    return this.state.redirectToBadges || !this.props.setupMode ? <Redirect to='/admin/badges' /> : (
      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
          <Typography variant='h1'>Badge</Typography>
          {this.state.isLoading && <CircularProgress style={{ color: this.props.statusColor.main }} />}
        </div>

        {this.state.badge != null &&
        <div style={{ width: '100%' }}>
          <LineItem description='Badge Serial Number' value={this.state.badge.getSerialNumber()} />
          <LineItem description='Assigned Staff Member' value={this.state.badge.getBelongsTo()?.getName() ?? 'Unknown'} />
          
          {isSuperAdmin ? (
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="badge-type-label">Badge Type</InputLabel>
                <Select
                  labelId="badge-type-label"
                  value={this.state.selectedBadgeTypeID || ''}
                  onChange={this.handleBadgeTypeChange}
                  label="Badge Type"
                  disabled={this.state.isSaving}
                >
                  {this.state.badgeTypes.map(badgeType => (
                    <MenuItem key={badgeType.getID()} value={badgeType.getID()}>
                      {badgeType.getName()}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              
              <Button
                variant="contained"
                style={{ 
                  marginTop: '15px',
                  backgroundColor: this.props.statusColor.main, 
                  color: this.props.statusColor.text 
                }}
                onClick={this.handleSaveBadgeType}
                disabled={this.state.isSaving || this.state.selectedBadgeTypeID === this.state.badge.getBadgeType()?.getID()}
                fullWidth
              >
                {this.state.isSaving ? 'Saving...' : 'Save Badge Type'}
              </Button>
            </div>
          ) : (
            <LineItem description='Badge Type' value={this.state.badge.getBadgeType()?.getName() ?? 'Unknown'} />
          )}
        </div>}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus.getColor(),
  setupMode: state.setupMode.mode || state.setupMode.isLoading,
  userType: state.auth.userType
});

const mapDispatchToProps = dispatch => ({
  setError: (msg) => setAlert(dispatch, msg),
  setSuccess: (msg) => setSuccess(dispatch, msg),
  clearErrors: () => dispatch(clearErrors())
});

Badge.propTypes = {
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  clearErrors: PropTypes.func,
  match: PropTypes.object.isRequired,
  statusColor: PropTypes.object.isRequired,
  setupMode: PropTypes.bool.isRequired,
  userType: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Badge));